import * as yup from "yup";
import "yup-phone";
import moment from "moment";
import parsePhoneNumber from "libphonenumber-js";

export const SignUpSchema = yup.object().shape({
  first_name: yup
    .string()
    .required("First Name is required.")
    .max(100, "First Name must be 100 characters or less"),
  last_name: yup
    .string()
    .required("Last Name is required")
    .max(100, "Last Name must be 100 characters or less"),
  email: yup.string().required("Email is required").email(),
  mobile_number: yup
    .string()
    .required("Mobile number is required")
    .phone("", "", "Enter valid number"),
  countryCode: yup.string(),
  password: yup
    .string()
    .required("Password is required")
    .matches(/[a-zA-Z]/, "Password must contain at least one letter")
    .matches(/[0-9]/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      "Password must contain at least one special character"
    )
    .min(8, "Password must be at least 8 characters long"),
  passwordConfirmation: yup
    .string()
    .required("Password confirmation is required")
    .oneOf([yup.ref("password")], "Passwords must match"),
});

export const completeProfileStudent = yup.object().shape({
  first_name: yup
    .string()
    .required("First Name is required.")
    .max(100, "First Name must be 100 characters or less"),
  last_name: yup
    .string()
    .required("Last Name is required")
    .max(100, "Last Name must be 100 characters or less"),
  email: yup.string().required("Email is required").email(),
  mobile_number: yup.string().phone().required("Mobile number is required"),
  dob: yup
    .string()
    .required("Invalid Date")
    .test("dob", "Please enter a valid date of birth. Student's age must be at least 4 years", (date) => {
      if (!date) return false;
      
      const birthDate = moment(date, "YYYY-MM-DD");
      const today = moment();
      const age = today.diff(birthDate, 'years');
      
      return age >= 4 && age <= 80;
    }), 
  password: yup.string().required("Password is required"),
  photo: yup.string().required("User photo is required."),
});

export const editStudentProfile = yup.object().shape({
   first_name: yup
    .string()
    .required("First Name is required.")
    .max(100, "First Name must be 100 characters or less"),
  last_name: yup
    .string()
    .required("Last Name is required")
    .max(100, "Last Name must be 100 characters or less"),
  email: yup.string().required("Email is required").email(),
  mobile_number: yup.string().required("Mobile number is required"),
  dob: yup
    .string()
    .required("Invalid Date")
    .test("dob", "Please enter a valid date of birth. Student's age must be at least 4 years ", (date) => {
      if (!date) return false;
      
      const birthDate = moment(date, "YYYY-MM-DD");
      const today = moment();
      const age = today.diff(birthDate, 'years');
      
      return age >= 4 && age <= 80;
    }),
  photo: yup.string().required("User photo is required."),
});

// yup.addMethod(yup.mixed, "validateFunction", validateFunction);

yup.addMethod(yup.mixed, "selectFieldValidate", function (errorMessage) {
  return this.test(
    `selectFieldValidate`,
    errorMessage,
    function (countryValue) {
      const { countryCode } = this.options.parent;
      const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

      if (regionNames.of(countryCode.toUpperCase()) !== countryValue.value)
        return false;

      return !countryValue.value ? false : true;
    }
  );
});

export const editTeachersProfile = yup.object().shape({
  first_name: yup
    .string()
    .required("First Name is required.")
    .max(100, "First Name must be 100 characters or less"),
  last_name: yup
    .string()
    .required("Last Name is required")
    .max(100, "Last Name must be 100 characters or less"),
  email: yup.string().required("Email is required").email(),
  mobile_number: yup.string().required("Mobile number is required"),
  photo: yup.string().required("User photo is required."),
  dob: yup
    .string()
    .required("Invalid Date")
    .test("dob", "Teacher must be between 18 and 80 years old", (date) => {
      if (!date) return false;
      
      const birthDate = moment(date, "YYYY-MM-DD");
      const today = moment();
      const age = today.diff(birthDate, 'years');
      
      return age >= 18 && age <= 80;
    }),
  country: yup
    .object()
    .selectFieldValidate("Country not match with Mobile Number"),
  state: yup
    .object()
    .required()
    .test("state", "State is Required", (value) =>
      !value.value ? false : true
    ),
  city: yup
    .object()
    .required()
    .test("state", "City is Required", (value) =>
      !value.value ? false : true
    ),
  countryCode: yup.string(),
  countryDial: yup.string(),
});

export const TeacherCompleteProfile = yup.object().shape({
  first_name: yup.string().required("First Name is required."),
  last_name: yup.string().required("Last Name is required"),
  email: yup.string().required("Email is required").email(),
  mobile_number: yup.string().required("Mobile number is required"),
  photo: yup.string().required("User photo is required."),
  dob: yup
    .string()
    .required("Date is required")
    .test("dob", "Teacher must be between 18 and 80 years old", (date) => {
      if (!date) return false;
      const birthDate = moment(date, "YYYY-MM-DD");
      const today = moment();
      const age = today.diff(birthDate, 'years');
      
      return age >= 18 && age <= 80;
    }),
  country: yup
    .object()
    .selectFieldValidate("Country not match with Mobile Number"),
  state: yup
    .object()
    .required()
    .test("state", "State is Required", (value) =>
      !value.value ? false : true
    ),
  city: yup
    .object()
    .required()
    .test("state", "State is Required", (value) =>
      !value.value ? false : true
    ),
  countryCode: yup.string(),
  countryDial: yup.string(),
  password: yup.string().required("Password is required"),
  passwordConfirmation: yup
    .string()
    .required("Password confirmation is required")
    .oneOf([yup.ref("password")], "Passwords must match"),
});

export const LoginSchema = yup.object().shape({
  email: yup.string().required("Email is required").email(),
  password: yup.string().required("Password is required"),
});

export const AddStudentsToClassSchema = yup.object({
  students: yup.array().of(
    yup.object().shape({
      first_name: yup.string().required("First Name is required."),
      last_name: yup.string().required("Last Name is required"),
      email: yup
        .string()
        .required("Email is required")
        .email("enter valid email"),
      mobile_number: yup
        .string()
        .required("Mobile number is required")
        .phone("", "", "Number is not valid"),
    })
  ),
});

export const CreateVirtualClassSchema = yup.object().shape({
  date: yup
    .date()
    .required("Date is required.")
    .min(new Date(), "Date and Time must be in the future"),
  title: yup
    .string()
    .required("Title is required.")
    .max(255, "Title cannot exceed 255 characters")
    .trim(),
  duration_seconds: yup
    .object()
    .required("Duration is required")
    .test(
      "is-valid-duration",
      "Invalid duration selected",
      (value) => value && value.value > 0
    ),
  subject: yup
    .object()
    .required("Subject is required.")
    .test(
      "has-subject-id",
      "Invalid subject selected",
      (value) => value && value.subject && value.subject.id
    ),
  repeats: yup
    .object()
    .required("Repeat is required.")
    .test(
      "is-valid-repeat",
      "Invalid repeat option",
      (value) => value && value.value
    ),
  description: yup
      .string()
      .test(
        "char-count",
        "Description must be 1000 characters or less",
        (value) => !value || value.length <= 1000
      ),
});

export const EditVirtualClassSchema = yup.object().shape({
  title: yup
    .string()
    .required("Title is required.")
    .max(255, "Title cannot exceed 255 characters")
    .trim(),
  duration_seconds: yup
    .object()
    .required("Duration is required")
    .test(
      "is-valid-duration",
      "Invalid duration selected",
      (value) => value && value.value > 0
    ),
  subject: yup
    .object()
    .required("Subject is required.")
    .test(
      "has-subject-id",
      "Invalid subject selected",
      (value) => value && value.subject && value.subject.id
    ),
  repeats: yup
    .object()
    .required("Repeat is required.")
    .test(
      "is-valid-repeat",
      "Invalid repeat option",
      (value) => value && value.value
    ),
   description: yup
    .string()
    .test(
      "char-count",
      "Description must be 1000 characters or less",
      (value) => !value || value.length <= 1000
    ),
});
export const editStudentDetailsSchema = yup.object().shape({
  first_name: yup.string().required("First Name is required."),
  last_name: yup.string().required("Last Name is required"),
  email: yup.string().required("Email is required").email(),
  mobile_number: yup.string().phone().required("Mobile number is required"),
});

export const studentExcelFileSchema = {
  "First Name": {
    // JSON object property name.
    prop: "first_name",
    type: String,
    required: true,
  },
  "Last Name": {
    prop: "last_name",
    type: String,
    required: true,
  },
  "Mobile Number": {
    prop: "mobile_number",
    required: true,
    type: (value) => {
      const number = parsePhoneNumber(value.toString());
      if (!number) {
        throw new Error("Invalid Mobile Number");
      }
      return number.number;
    },
  },
  Email: {
    prop: "email",
    type: String,
    required: true,
  },
};

yup.addMethod(yup.mixed, "checkTimeCover", function (errorMessage) {
  return this.test(`checkTimeCover`, errorMessage, function (countryValue) {
    const { countryCode } = this.classDuration.parent;
    const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

    if (regionNames.of(countryCode.toUpperCase()) !== countryValue.value)
      return false;

    return !countryValue.value ? false : true;
  });
});

export const CreateClassPlanSchema = yup.object({
  classPlan: yup.array().of(
    yup.object().shape({
      title: yup.string()
        .required("Title is required.")
        .trim()
        .min(2, "Title must be at least 2 characters")
        .max(100, "Title cannot exceed 100 characters"),
      
      timeToCover: yup
        .number()
        .typeError("Time must be a number")
        .integer("Time must be a whole number (no decimals)") // This ensures it's an integer
        .positive("Time must be a positive number")
        .required("Time is required")
        .test(
          "time-validation",
          "Time cannot exceed total class duration",
          function(value) {
            const totalDuration = Number(this.parent.classDuration);
            return value <= totalDuration;
          }
        ),
      
      checkGroupSelection: yup
        .string()
        .test(
          "checkGroupSelection",
          "At least one selection is required (Assignment/Content/Question)",
          function() {
            const defaultValue = "Select Options";
            const { assignment, question, content } = this.parent;
            
            return (
              content?.value !== defaultValue ||
              assignment?.value !== defaultValue ||
              question?.value !== defaultValue
            );
          }
        ),
    })
  ),
});



export const AddingAssignmentSchema = yup.object({
  dueDays: yup
    .string()
    .required("Enter No of days")
    .matches(/^[0-9]+$/, "Only numeric input is allowed")
    .test(
      'min-max',
      'Must be between 0-365 days',
      (value) => {
        const num = Number(value);
        return num >= 0 && num <= 365; // 0-365 validation
      }
    ),
  assignTo: yup.object().required("Select the assign to"),
  markOf: yup.object().required("Select the mark of"),
});